import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import { StringValue } from "./StringValue";
import CardContent from "@material-ui/core/CardContent";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Recall Mines">
      <CardContent>
        <AccountDetailsSection task={task} />
        <StatusSection task={task} />
        {task.taskstatusdetail.portcitiestocorners && (
          <>
            <StringValue
              label={"Use Speedups?"}
              value={task.taskstatusdetail.speedrecall}
            />
          </>
        )}
        <StringValue
          label={"Marches Recalled"}
          value={task.taskstatusdetail.marchesrecalled}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
